



















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import Inputfield from "@/components/partials/Inputfield.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import { APICredential } from "@/interfaces/entities/APICredential";

@Component({
    components: { TDSSpinner, TDSModal, TDSButton, Inputfield, DefaultLayout }
})
export default class SalesChannel extends Vue {
    private webhooksModalOpen: boolean = true;
    private editModalOpen: boolean = false;
    private fsModalOpen: boolean = false;
    private channelName: string = "";
    private selectedChannel: APICredential | null = null;
    private mobileSwitchOpen: boolean = false;
    private selectedStep: string = "retrieveToken";
    private isLoading: boolean = true;
    private isResetting: boolean = false;
    private isDeleting: boolean = false;
    private deleteModalOpen: boolean = false;
    private channelToDelete: APICredential | null = null;
    private isSavingName: boolean = false;
    private resetModalOpen: boolean = false;
    private channelToReset: APICredential | null = null;
    private baseUrl: string | undefined = process.env.VUE_APP_API_URL;

    get steps(): { [key: string]: string } {
        let url: string = "https://api.giga.store";
        if (this.baseUrl?.includes("llamaapi")) url = "https://apigw.llamaapi.io";
        if (this.baseUrl?.includes("dromedaryapi")) url = "https://apigw.dromedaryapi.io";
        return {
            retrieveToken: `curl --location --request POST '${url}/reseller/authenticate'
--header 'Authorization: Basic ${btoa(this.selectedChannel?.clientId + ":" + this.selectedChannel?.clientSecret)}'`,
            getInventory: `curl --location --request GET '${url}/gigastore/products/inventory'
--header 'Authorization: Bearer eyJhbGciO...YOUR_ACCESS_TOKEN...`,
            activatePackage: `curl --location --request POST '${url}/gigastore/activations/register'
--header 'Authorization: Bearer eyJhbGc...YOUR_ACCESS_TOKEN...'
--header 'Content-Type: application/json'
--data-raw '{
    "inventoryItemId": "00e3e46e-faa5-465a-9321-2f9b719ce79c",
    "metatag": "Comment for reseller..."
}'`,
            // eslint-disable-next-line quotes
            tunzBranding: '<a href="https://tunz.giga.store"><img src="https://tunz.giga.store/powered-by.svg"></a>'
        };
    }

    get channels() {
        return this.$store.state.apiChannels;
    }

    get nameSaveDisabled(): boolean {
        if (!this.selectedChannel || this.isSavingName) return true;
        const trimmed = (this.channelName || "").trim();
        if (!trimmed) return true;
        const current = (this.selectedChannel.name || "").trim();
        return trimmed === current;
    }

    get isMobile(): boolean {
        return this.$store.state.isMobile;
    }

    created() {
        document.title = process.env.VUE_APP_THEME_TITLE + " | " + this.$t("apiDashboard.pageTitle");
        this.fetchCredentials();
    }

    mounted() {
        this.calcTextareaHeight();
    }

    @Watch("isMobile")
    mobileChanged() {
        this.calcTextareaHeight();
    }

    @Watch("selectedStep")
    selectedStepChanged() {
        this.$nextTick(() => {
            this.calcTextareaHeight();
        });
    }

    @Watch("fsModalOpen")
    fsModalOpenChanged(value: boolean) {
        if (value) {
            this.$nextTick(() => {
                this.calcTextareaHeight();
            });
        }
    }

    @Watch("channels")
    channelsChanged() {
        if (this.channels.length === 0) {
            this.selectedChannel = null;
            return;
        }

        if (this.selectedChannel) {
            const matching = this.channels.find((c: APICredential) =>
                this.selectedChannel?.id !== undefined
                    ? c.id === this.selectedChannel?.id
                    : c.clientId === this.selectedChannel?.clientId
            );
            if (matching) {
                this.selectedChannel = matching;
                return;
            }
        }

        this.selectedChannel = this.channels[0];
    }

    private async fetchCredentials() {
        this.isLoading = true;
        try {
            await this.$store.dispatch("FETCH_API_CREDENTIALS");
        } catch (e) {
            console.log("[API Dashboard] Failed fetching API credentials");
        } finally {
            this.isLoading = false;
        }
    }

    private calcTextareaHeight() {
        const textarea = this.$refs.request as HTMLTextAreaElement;
        if (!textarea) return;
        const lines = textarea.value.split(/\n/g) || [];
        // lines x line-height + padding + border
        const maxChars = this.isMobile ? 33 : 100;
        let numberOfLines = 0;
        lines.forEach((line: string) => {
            numberOfLines += Math.ceil(line.length / maxChars);
        });
        textarea.style.height = (this.isMobile ? numberOfLines * 16 + 70 : numberOfLines * 14 + 46) + "px";
    }

    // NEEDED LATER
    private addChannel() {
        this.isLoading = true;
        this.$store
            .dispatch("CREATE_API_CREDENTIALS")
            .then((created: APICredential) => {
                this.selectedChannel = created;
            })
            .catch(() => {
                this.$toastr.error(this.$t("apiDashboard.sales.addFailed") as string);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    private editChannel() {
        if (!this.selectedChannel || !this.selectedChannel.clientId) return;
        this.channelName = this.selectedChannel.name ? this.selectedChannel.name : "";
        this.editModalOpen = true;
    }

    private async saveName() {
        if (this.nameSaveDisabled || !this.selectedChannel) return;
        const name = (this.channelName || "").trim();
        this.isSavingName = true;
        try {
            const updated: APICredential = await this.$store.dispatch("UPDATE_API_SALES_CHANNEL", {
                name,
                clientId: this.selectedChannel.clientId
            });
            this.selectedChannel = updated;
            this.editModalOpen = false;
            this.$toastr.success(this.$t("apiDashboard.sales.nameUpdated") as string, true, true);
        } catch (e) {
            console.log("[API Dashboard] Failed updating sales channel name", e);
            this.$toastr.error(this.$t("apiDashboard.sales.nameUpdateFailed") as string);
        } finally {
            this.isSavingName = false;
        }
    }

    private async resetSelectedChannel() {
        if (!this.selectedChannel?.id) return;

        this.isResetting = true;
        try {
            const renewed: APICredential = await this.$store.dispatch(
                "RENEW_API_CREDENTIALS",
                this.selectedChannel.id
            );
            this.selectedChannel = renewed;
        } catch (e) {
            console.log("[API Dashboard] Failed resetting API credentials", e);
            this.$toastr.error(this.$t("apiDashboard.sales.resetFailed") as string);
        } finally {
            this.isResetting = false;
        }
    }

    private openResetModal() {
        if (!this.selectedChannel?.id) return;
        this.channelToReset = this.selectedChannel;
        this.resetModalOpen = true;
    }

    private async confirmReset() {
        if (!this.channelToReset?.id) return;
        this.resetModalOpen = false;
        this.selectedChannel = this.channelToReset;
        await this.resetSelectedChannel();
    }

    private openDeleteModal() {
        if (!this.selectedChannel?.id) return;
        this.channelToDelete = this.selectedChannel;
        this.deleteModalOpen = true;
    }

    private async confirmDelete() {
        if (!this.channelToDelete?.id) return;
        const channel = this.channelToDelete;
        this.deleteModalOpen = false;
        await this.deleteChannel(channel);
    }

    private async deleteChannel(channel: APICredential) {
        if (!channel.id || this.isDeleting) return;
        this.isDeleting = true;
        try {
            await this.$store.dispatch("DELETE_API_CREDENTIALS", channel.id);
        } catch (e) {
            console.log("[API Dashboard] Failed deleting API credentials", e);
            this.$toastr.error(this.$t("apiDashboard.sales.deleteFailed") as string);
        } finally {
            this.isDeleting = false;
        }
    }

    // // NEEDED LATER
    // private removeChannel() {
    //     if (!this.selectedChannel) return;
    //     this.$store.commit("REMOVE_CHANNEL", this.selectedChannel.id);
    //     this.selectedChannel = this.channels ? this.channels[0] : [];
    // }

    private copyRequest(text: string) {
        const toastr = this.$toastr;
        const success = this.$t("components.inputfield.copied");
        navigator.clipboard.writeText(text.replace(/[\r\n]/gm, " ")).then(function() {
            toastr.success(success, true, true);
        });
    }

    private nextStep() {
        if (this.selectedStep === "retrieveToken") this.selectedStep = "getInventory";
        else if (this.selectedStep === "getInventory") this.selectedStep = "activatePackage";
        else if (this.selectedStep === "activatePackage") this.selectedStep = "tunzBranding";
    }

    private prevStep() {
        if (this.selectedStep === "getInventory") this.selectedStep = "retrieveToken";
        else if (this.selectedStep === "activatePackage") this.selectedStep = "getInventory";
        else if (this.selectedStep === "tunzBranding") this.selectedStep = "activatePackage";
    }

    private toggleMobileOpen() {
        if (this.channels.length < 2) return;
        this.mobileSwitchOpen = !this.mobileSwitchOpen;
    }
}
